<template>
  <div class="d-flex justify-content-center bg-white vh-100">
    <!-- Mobile View Container -->
    <div class="d-flex flex-column bg-light w-100" style="height: 90vh">
      <!-- Fixed Top Navbar -->
      <div class="container-fluid fixed-top bg-light shadow-sm py-2 w-100">
        <div class="d-flex flex-column align-items-center px-2">
          <div class="d-flex justify-content-between align-items-center w-100">
            <div class="d-flex align-items-center">
              <button
                class="btn bg-transparent p-0 me-2 mb-3"
                data-bs-toggle="modal"
                data-bs-target="#sidebarModal"
              >
                <i class="fas fa-list text-dark fs-4"></i>
              </button>
              <div>
                <p class="text-muted mb-0">Namaste</p>
                <p class="fw-semibold text-capitalize text-dark mb-0">
                  {{ profile.name }} <span>ji</span>
                </p>
              </div>
            </div>
            <div class="my-2 text-center">
              <img src="/app/images/bloom-logo.png" style="width: 20vw" />
            </div>
            <div class="bg-light rounded px-3 py-2 text-dark text-start">
              <div class="d-flex justify-content-between">
                <p class="fw-bold mb-0">{{id}}</p>
                <p class="mb-0 text-muted small">My Rank</p>
              </div>
              <div class="d-flex align-items-center gap-4">
                <p class="fw-bold mb-0">0</p>
                <p class="mb-0 text-muted small">Karma Points</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div class="flex-grow-1 mt-4 pt-4 overflow-auto">
        <div class="container-fluid mt-5 px-3">
          <div class="w-100 mx-auto bg-white rounded shadow-sm p-4 plan-heading">
            <h2 class="fs-6 text-dark fw-medium">Yoga Challenge</h2>

            <!-- Progress Bar -->
            <div
              class="progress my-2 rounded-pill"
              style="height: 19px; background-color: #ececec"
            >
              <div
                class="progress-bar"
                role="progressbar"
                style="
                  width: 0%;
                  background-color: #50b1ac;
                  border-radius: 100px;
                "
              ></div>
              <div class="text-center text-muted" style="margin-left: 46%">
                0 day/14 days
              </div>
            </div>
            <!-- Days Completed -->
            <div class="d-flex justify-content-end">
              <p class="small text-dark fw-normal mb-0">
                <span class="fw-bold">Starts on 10th Feb</span>
              </p>
            </div>
          </div>
        </div>

        <div class="container-fluid mt-1 rounded px-3">
          <div class="rounded bg-white p-4 shadow-sm">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <p class="fs-5 fw-medium">Referral Rewards</p>
              <a
                href="javascript:void(0)"
                class="text-dark border border-secondary rounded-pill px-3 py-0 text-decoration-none"
                >See Rewards</a
              >
            </div>
            <div
              class="tooltip bs-tooltip-top show ms-5"
              role="tooltip"
              style="
                background-color: rgb(255, 228, 161);
                color: rgb(0, 0, 0);
                border-radius: 8px;
                padding: 8px 12px;
                box-shadow: rgba(182, 182, 182, 0.5) 0px 7px 10px 0px;
              "
            >
              Unlock your <i class="fas fa-gift text-danger"></i>
              <span class="font-weight-bold text-dark">7 day yoga voucher</span
              ><br />
              at just
              <span class="font-weight-bold text-dark">1 referral!</span>
              <div class="arrow" style="transform: translateX(-50%)"></div>
            </div>

            <div class="d-flex justify-content-center mt-4">
              <div class="d-flex align-items-center">
                <!-- Level 0 -->
                <div class="d-flex flex-column align-items-center">
                  <div>
                    <i class="fas fa-check-circle fa-2x text-warning"></i>
                  </div>
                  <div class="text-center">
                    <p class="font-weight-bold small mb-1">Level 0</p>
                    <p class="font-weight-medium small mb-1">0 KP</p>
                  </div>
                </div>

                <!-- Progress Bar -->
               
                <div class="d-flex gap-1 pb-3 ml-n1">
                  <div
                    v-for="n in 5"
                    :key="n"
                     :class="n <= ((Math.ceil((expiredIn / 25) * 5))%5) ? 'disClr  ' : (((Math.ceil((expiredIn / 25) * 5))%5)==0 ? 'disClr ' :'bg-secondary ')"
                    style="height: 8px; width: 10vw"
                  ></div>
                </div>
                

                <!-- Level 1 -->
                <div class="d-flex flex-column align-items-center">
                  <div><i class="fas fa-lock fa-2x text-secondary"></i></div>
                  <div class="text-center">
                    <p class="font-weight-bold small mb-1">Level 1 </p>
                    <p class="font-weight-medium small mb-1">10 KP</p>
                  </div>
                </div>
              </div>
            </div>

            <p class="fs-6 my-3">
              Get a <i class="fas fa-tshirt text-success"></i> Bloom Prenatal Yoga Yoga
              T-Shirt at
              <strong>Level 4 <i class="fas fa-star text-warning"></i></strong>
            </p>
            <div
              class="border border-dark border-dotted rounded p-2 text-center mt-3"
            >
              <span class="mb-2 text-truncate">https://bloomprenatalyoga.in/K_agak</span>
              <button class="btn btn-sm btn-outline-dark border-0">
                <i class="fas fa-copy"></i> Copy
              </button>
            </div>

            <!-- Share Buttons -->
            <div class="d-flex justify-content-between mt-3">
              <a
                href="javascript:void(0)"
                class="btn text-white w-50 me-2 fs-6"
                style="background-color: #ff7345"
              >
                <i class="fas fa-qrcode"></i> WA Story
              </a>
              <a
                href="javascript:void(0)"
                class="btn text-white w-75 fs-6"
                style="background-color: #ff7345"
              >
                <i class="fab fa-whatsapp"></i> Share on WhatsApp
              </a>
            </div>

            <!-- How to Refer Section -->
            <div class="pt-3">
              <p class="fs-6 fw-medium">How to Refer?</p>
              <div class="mt-3">
                <div class="d-flex align-items-center gap-3 my-3">
                  <i class="fas fa-mobile-alt fa-2x mb-3 text-primary"></i>
                  <p class="small fw-semibold">
                    Click on “<u>Share on WhatsApp</u>” above to<br />
                    Generate your customised link
                  </p>
                </div>
                <div class="d-flex align-items-center gap-3 my-3">
                  <i class="fas fa-microphone-alt fa-2x text-danger"></i>
                  <p class="small fw-semibold">
                    Share it with your Friends / Family<br />
                    members
                  </p>
                </div>
                <div class="d-flex align-items-center gap-3 my-3">
                  <i class="fas fa-gift fa-2x text-warning"></i>
                  <p class="small fw-semibold">
                    Earn Karma Points (KP) when they join<br />
                    through your link and earn gifts. 1 Invite = 10 KP.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-light mt-1 px-3">
          <div class="bg-white p-3 rounded shadow-sm text-center">
            <div
              class="d-flex justify-content-evenly align-items-center flex-wrap"
            >
              <p class="mb-0 text-start fs-5">
                Do a <b>Quick Breathing</b><br />
                exercise for instant<br />
                calmness?
              </p>
              <img
                src="/app/images/breathing-yoga.png"
                class="h-25 w-25 me-5 rounded"
              />
            </div>
            <a
              href="/breathing"
              class="btn text-white rounded-pill w-100 mt-3 d-flex align-items-center justify-content-center gap-2"
              style="background-color: #ff7345"
            >
              <i class="fab fa-whatsapp"></i>
              <span>Invite 1 friend to UNLOCK</span>
            </a>
          </div>
          <div class="d-grid gap-2 px-4 mt-3 bg-white">
            <div>
              <button
                class="btn w-100 border border-secondary-subtle bg-white rounded shadow-sm py-2"
              >
                <i class="fas fa-clock text-primary"></i>
                <span class="ms-2 text-dark fw-medium">Batch Timings:</span><strong>{{ profile.timining }}</strong>
              </button>
            </div>
            <button
              class="btn btn-outline-secondary d-flex align-items-center justify-content-center gap-2"
            >
              <i class="fas fa-file-pdf text-danger"></i>
              <span class="text-sm fw-medium">Free PDF</span>
            </button>
          </div>
          <div class="bg-light mt-2 px-2 mb-5">
            <div
              class="rounded shadow-sm text-center"
              style="background-color: #744e41"
            >
              <div class="d-flex justify-content-center align-items-center text-center">
                <img
                  src="/app/images/breathing-yoga.png"
                  class="rounded-circle mt-2"
                  width="40px"
                  height="40px"
                />
                <p class="mb-0 text-start fs-6 text-white">
                  Do a <b>Quick Breathing</b> exercise for instant calmness?
                </p>
                <i class="fas fa-chevron-right mt-3 me-3"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- Fixed Bottom Navbar -->
        <div class="container-fluid fixed-bottom bg-white shadow-lg w-100">
          <div class="d-flex justify-content-around py-3">
            <router-link
              to="/dashboard"
              class="text-decoration-none text-center"
            >
              <div class="bg-opacity-10 rounded-circle d-inline-block">
                <i class="fas fa-home fs-5" style="color: #ff7345"></i>
              </div>
              <p class="mb-0 small fw-semibold "  style="color: #ff7345">Home</p>
            </router-link>
            <router-link
              to="/resources"
              class="text-decoration-none text-center blkClr"
            >
              <i class="fas fa-book fs-5 d-block"></i>
              <p class="mb-0 small fw-semibold">Resources</p>
            </router-link>
            <a
              class="text-muted text-decoration-none text-center"
              href="/referals"
            >
              <i class="fas fa-users fs-5 d-block"></i>
              <p class="mb-0 small fw-semibold">My Referral</p>
            </a>
          <router-link
                    to="/login"
                    class="text-decoration-none text-center  blkClr"
                  >
                  <div class="bg-opacity-10 rounded-circle d-inline-block">
                <i class="fas fa-sign-out-alt" ></i>
              </div>
              <p class="mb-0 small fw-semibold">Logout</p>
                  </router-link>
          </div>
        </div>

        <div
          class="modal fade"
          id="sidebarModal"
          tabindex="-1"
          aria-labelledby="sidebarModalLabel"
          aria-hidden="true"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div
            class="modal-dialog modal-fullscreen modal-dialog-start w-100"
          >
            <div class="modal-content">
              <div class="modal-body text-center">
                <div class="text-end">
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                  ></button>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <!-- Profile Icon -->
                  <i class="fas fa-user-circle fa-3x mb-4"></i>

                  <!-- Profile Info -->
                  <div>
                    <p class="fw-semibold text-start fs-5">
                      {{ profile.name }}<br />
                      <!-- <span class="text-dark fw-medium me-2 fs-6">
                        View Profile
                        <i class="fas fa-chevron-right"></i
                      ></span> -->
                    </p>
                  </div>
                </div>

              <!--   <div class="card text-center shadow-lg p-3 bg-light">
                  <h5>Personal Invite QR Code</h5>
                  <p>
                    Ask Your Friends to scan and gift<br />14 Days of FREE
                    ONLINE YOGA
                  </p>
                  <img
                    src="/app/images/qr-code.png"
                    width="200"
                    height="200"
                    class="ms-4"
                  />
                </div>
                <div class="text-center">
                  <button
                    class="btn text-white d-flex justify-content-center align-items-center gap-2 mt-3 mb-3 ms-5"
                    style="background-color: #ff7345"
                  >
                    <i class="fas fa-download"></i> Download QR
                  </button>
                </div> -->
                <div class="text-start">
                  <p><i class="fas fa-question-circle"></i> FAQ'S</p>
                  <router-link
                    to="/login"
                    class="text-decoration-none text-center"
                  >
                    <p class="text-start" data-bs-dismiss="modal"><i class="fas fa-sign-out-alt"></i> Logout</p>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Mobile View Container -->
    </div>
  </div>
</template>
<script>
import { ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  setup() {
    const profile = ref({
      name: "",
      mobile: "",
    });
    const store = useStore();
    const router = useRouter();
    const token = computed(() => store.state.user.token);
    const id = computed(() => store.state.user.id);
    const UserValidity = computed(() => store.state.validity);
    const expiredIn = computed(() => store.state.expiredIn);
   const checkAuth = () => {
      if (!token.value) {
        router.push("/login");
        return false;
      }
      return true;
    };
    const profileDetails = async () => {
       if (!checkAuth()) return;
      fetch(`${process.env.VUE_APP_API_URL}user/details/${id.value}`).then(
        async (res) => {
          let details = await res.json();
          profile.value = details[0];
          store.commit("setProfile", details[0].name);
        }
      );
    };
       watch(token, (newToken) => {
      if (!newToken) {
        router.push("/login");
      }
    });
      onMounted(() => {
      checkAuth();
      profileDetails();
    });
    return {
      profile,
      token,
      id,
      UserValidity,
      expiredIn,
      profileDetails,
    };
  },
};
</script>
<style>
.blkClr {
  color: var(--bs-secondary-color) !important;
}
@media (max-width: 991px) {
  #sidebarModal {
    width:90%
  }
}
@media (min-width: 992px) {
.plan-heading {
  margin-top: 6rem;
}
#sidebarModal {
  width:30%
}
}
.disClr {
  background-color: red !important;
}
</style>